export default __webpack_public_path__ + "static/media/ev-charge-point-placeholder.1183ab79.png";